import React from 'react';
import ReactDOM from 'react-dom';

import { initTranslate } from '~/services/translate/translate';
import { getLocale } from '~/core/utils';

import MainPage from './components/main-page';
import { init as initAuth0 } from './services/auth0';
import { initAnalytics } from './services/amplitude';
import { setupSocialProviders } from './core/social-providers';
import { setupRotatingAds } from './services/rotating-ads';
import { setupFeatures } from './core/features';
import { VPAAS_MODES } from '~/core/constants';
import initThemeListener from './services/theme';

const queryParams = new URLSearchParams(window.location.search);

const getVpaasMode = () => {
  const view = queryParams.get('view');
  if (view) {
    return VPAAS_MODES[view.toUpperCase()] || VPAAS_MODES.DEFAULT;
  }

  return VPAAS_MODES.DEFAULT;
}

window.addEventListener('load', async () => {
  if (window.matchMedia) {
    initThemeListener();
  }

  await initTranslate(getLocale());
  await setupSocialProviders();

  setupRotatingAds();
  setupFeatures();
  const config = window.auth0Config || {};

  config.mode = queryParams.get('mode') || 'login';
  config.referrer = queryParams.get('referrer') || document.referrer;
  config.isPaid = queryParams.get('isPaid') || queryParams.get('is_paid') || true;
  const deviceId = queryParams.get('device_id') || queryParams.get('deviceId');
  config.isVpaaS = queryParams.get('is_vpaas') || queryParams.get('isVpaas');
  config.prefillEmail = queryParams.get('prefill_email') || queryParams.get('prefillEmail') || queryParams.get('email');
  config.vpaasMode = getVpaasMode();


  const params = Object.assign({
    redirectUrl: config.callbackURL,
    responseType: (config.internalOptions || {}).response_type ||
      (config.callbackOnLocationHash ? 'token' : 'code'),
    params: config.internalOptions,
    clientID: config.clientID || AUTH0_CLIENT_ID_PILOT,
    domain: config.auth0Domain || AUTH0_DOMAIN_PILOT,
  }, config.internalOptions);

  initAuth0(params, config);
  await initAnalytics(deviceId);

  ReactDOM.render(<MainPage isPaid={config.isPaid} />, document.getElementById('root'));
});
